import React, { Component } from 'react';
import { translate } from '../services';

export class ErrorComponent extends Component {
  constructor() {
    super();
    this.state = {
      stack: 0
    };
  }
  handleReload() {
    document.location.reload( true );
  }
  stopPropagation = e => {
    e.preventDefault(); 
    return false;
  }
  toggleStack = e => {
    e.preventDefault();
    this.setState( oldState => ({ stack: oldState.stack === 0 ? 1 : 0 }) );
    return false;
  }
  render() {
    const { error } = this.props;
    return <div className="fatal-error" onClick={ this.stopPropagation }>
      <h3>{ translate('error occured') }</h3>
      <p>An error occured trying to render the current page, if this error persist please contact us</p>
      <p className="error-message">
        { error.message.split('\n').map( (l, i) => <span className="fixed" key={i}>{ l }</span> ) }
      </p>
      <p className="stack-trace" onClick={ this.toggleStack }>
      { ( this.state.stack === 0 ? 'Click to see the stack' : error.stack ).split('\n').map( (l, i) => <span className="fixed" key={i}>{ l }</span> ) }
      </p>
      <p>
        Please <a href="#/" onClick={ this.handleReload }>reload the page</a> to continue
      </p>
    </div>
  }
};
